
import { Component, Vue, Watch } from 'vue-property-decorator';

import { DeviceInfo, DeviceType } from '@/types/device-info';
import { Action, State } from 'vuex-class';
import * as dlg from '@/modules/dlg';
import DeviceQuickActions from '@/components/quick-actions/DeviceQuickActions.vue';
import { ToggleButton } from 'vue-js-toggle-button';
import { actions } from '@/store/types';
import { UpdateDeviceActionType } from '@/types/store/actions';
import { enableDisableOptions } from '@/constants/options';

@Component({
    components: { DeviceQuickActions, ToggleButton },
})
export default class DeviceSecuritySettings extends Vue {
    enableDisableOptions = enableDisableOptions;

    tsaAccessible = true;
    emergencyMode = false;
    DeviceTypeenum = DeviceType;

    @State('device')
    device!: DeviceInfo;

    @Action(actions.UPDATE_DEVICE)
    updateDevice!: UpdateDeviceActionType;

    mounted() {
        if (![DeviceType.AirboltGps].includes(this.device.deviceType)) {
            Vue.toasted.error('Permission denied');
            return this.$router.push({
                name: 'device-overview',
                params: { deviceUUID: this.device.deviceUUID as string },
            });
        }
    }

    async resetButtonCode() {
        dlg.notImplemented();
    }

    async save(e: Event) {
        e.preventDefault();
        await this.updateDevice({
            device: {
                _id: this.device._id,
                tsaAccessible: this.tsaAccessible,
                emergencyMode: this.emergencyMode,
            },
        });
    }

    @Watch('device', { immediate: true, deep: true })
    onDeviceChanged(device: DeviceInfo) {
        // console.log(`>> Tab updated from watcher ${this.constructor.name}`);

        if (device) {
            this.tsaAccessible = device.tsaAccessible;
            this.emergencyMode = device.emergencyMode;
        }
    }
}
